<template>
  <div class="table-edit-row">
    <el-input
      size="small"
      v-model="textValue"
      :placeholder="placeholder"
      class="table-edit-input"
    ></el-input>
    <el-button
      type="success"
      size="mini"
      icon="el-icon-check"
      class="table-edit-btn"
      @click="confirmEdit"
    ></el-button>
    <el-button
      type="danger"
      size="mini"
      icon="el-icon-close"
      class="table-edit-btn"
      @click="cancelEdit"
    ></el-button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
        type: [String,Number],
        default: ""
    },
    placeholder: {
        type: [String],
        default: "请输入"
    }
  },
  data() {
    return {
      textValue: "",
    };
  },
  watch: {
    textValue(newValue, oldValue) {
      this.$emit("input", this.textValue);
    },
  },
  created() {
    this.textValue = this.value;
  },
  methods: {
    confirmEdit() {
      this.$emit("confirm");
    },
    cancelEdit() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.table-edit-row {
  box-sizing: border-box;
  width: 100%;
  padding: 0 10px;
  display: flex;
  align-items: center;
  .table-edit-input {
    box-sizing: border-box;
    flex: 1;
    min-width: 100px;
    padding-right: 10px;
  }
}
</style>